export interface CartFeatureRoutesConfig {
  path: string;
}

export const defaultCartFeatureRoutesConfig: CartFeatureRoutesConfig = {
  path: 'saved',
};
